
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3japI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f1706ba794098d3b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $f1706ba794098d3b$export$2e2bcd8739ae039 = {
    'fabric.reactions.add': "\u30EA\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u8FFD\u52A0",
    'fabric.reactions.error.unexpected': "\u30EA\u30A2\u30AF\u30B7\u30E7\u30F3\u306F\u4E00\u6642\u7684\u306B\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002",
    'fabric.reactions.loading': "\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...",
    'fabric.reactions.more.emojis': "\u305D\u306E\u4ED6\u306E\u7D75\u6587\u5B57",
    'fabric.reactions.other.reacted.users': "{count, plural, other {\u3001\u4ED6 {count} \u4EBA}}",
    'fabric.reactions.reactwithemoji': "\u7D75\u6587\u5B57 {emoji} \u3067\u30EA\u30A2\u30AF\u30B7\u30E7\u30F3",
    'fabric.reactions.summary': "\u30E6\u30FC\u30B6\u30FC\u306B\u3088\u308B\u3059\u3079\u3066\u306E\u30EA\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u8868\u793A",
    'reaction-picker-trigger.add.reaction.message': "\u30EA\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u8FFD\u52A0",
    'reactions.dialog.close': "\u9589\u3058\u308B",
    'reactions.dialog.emoji.name': '{emojiName}',
    'reactions.dialog.left.navigate': "\u5DE6\u306B\u79FB\u52D5",
    'reactions.dialog.reactions.count': "{count, plural, other {\u5408\u8A08 {count,number} \u4EF6\u306E\u30EA\u30A2\u30AF\u30B7\u30E7\u30F3}}",
    'reactions.dialog.right.navigate': "\u53F3\u306B\u79FB\u52D5",
    'reactions.dialog.viewall': "\u3059\u3079\u3066\u8868\u793A",
    'reactions.dialog.viewall.tooltip': "\u30E6\u30FC\u30B6\u30FC\u306B\u3088\u308B\u3059\u3079\u3066\u306E\u30EA\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u8868\u793A"
};

});


//# sourceMappingURL=ja.1d4718b4.js.map
